<template>
    <div class="position-settings">
        <el-form :inline="true" size="small" :model="dataForm" @keyup.enter.native="getDataList()">
            <el-form-item label="岗位编码:">
                <el-input size="small" v-model="dataForm.code" placeholder="岗位编码" clearable></el-input>
            </el-form-item>
            <el-form-item label="岗位名称:">
                <el-input size="small" v-model="dataForm.name" placeholder="岗位名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
                <el-button size="small" type="primary" name="but_add"
                           @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新增
                </el-button>
                <el-button size="small" type="primary" name="but_add"
                           @click="orgUpdateHandle()" icon="el-icon-menu">
                    关联所属组织
                </el-button>
                <el-button size="small" type="success" name="but_add"
                           @click="dataAuthorityUpdateHandle()" icon="el-icon-menu">
                    配置数据权限
                </el-button>
            </el-form-item>
        </el-form>
        <el-table :data="dataList" v-loading="dataListLoading" size="small" :height=documentClientHeight
                  @selection-change="selectionChangeHandle" style="width: 100%;">
            <el-table-column type="selection" header-align="center" align="center" width="50">
            </el-table-column>
            <el-table-column type="index" label="序号" header-align="left" align="left" width="50">
            </el-table-column>
            <el-table-column prop="positionName" header-align="left" align="left" width="150" label="岗位名称">
            </el-table-column>
            <el-table-column prop="positionCode" header-align="left" align="left" width="150" label="岗位编码">
            </el-table-column>
            <el-table-column prop="contactPhone" header-align="left" align="left" width="120" label="联系方式">
                <template slot-scope="scope">
                    {{ scope.row.contactPhone || '-' }}
                </template>
            </el-table-column>
            <!--<el-table-column prop="mainBodyName" header-align="left" align="left" :show-overflow-tooltip="true" label="主体">-->
            <!--</el-table-column>-->
            <el-table-column prop="orgName" header-align="left" align="left" :show-overflow-tooltip="true" label="组织">
            </el-table-column>
            <!--<el-table-column prop="tenantName" header-align="left" align="left" min-width="100" label="租户">-->
            <!--</el-table-column>-->
            <el-table-column prop="dataAuthority" header-align="left" align="left" :show-overflow-tooltip="true" label="数据权限">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.dataAuthority === null || scope.row.dataAuthority === '0'">个人</el-tag>
                    <el-tag v-else-if="scope.row.dataAuthority === '-1'" type="danger">所有</el-tag>
                     <el-tag v-else-if="scope.row.dataAuthority === '2'" type="warning">所在子公司</el-tag>
                    <el-tag v-else type="success">所在组织</el-tag>
                </template>
            </el-table-column>
            <el-table-column header-align="left" align="left" min-width="180" label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small"
                               @click="addOrUpdateHandle(scope.row.id)" icon="el-icon-edit">
                        修改
                    </el-button>
                    <el-button type="text" size="small"
                               @click="deleteHandle(scope.row.id)" icon="el-icon-delete">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                       :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        <Org-update v-if="orgUpdateVisible" ref="orgUpdate" @refreshDataList="getDataList"></Org-update>
        <data-authority-update v-if="dataAuthorityUpdateVisible" ref="dataAuthorityUpdate" @refreshDataList="getDataList"></data-authority-update>
    </div>
</template>

<script>
    import {fetchPositionList, deletePosition} from '@/controller/sys'
    import AddOrUpdate from './position-add-or-update'
    import OrgUpdate from './org-update'
    import DataAuthorityUpdate from './data-authority-update'

    export default {
        data() {
            return {
                documentClientHeight: document.documentElement['clientHeight'] - 220,
                dataForm: {
                    name: '',
                    code: ''
                },
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false,
                orgUpdateVisible: false,
                dataAuthorityUpdateVisible: false
            }
        },
        components: {
            AddOrUpdate,
            OrgUpdate,
            DataAuthorityUpdate
        },
        activated() {
            this.getDataList()
        },
        methods: {
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true
                fetchPositionList(
                    {
                        'pageNo': this.pageIndex,
                        'pageSize': this.pageSize,
                        'positionCode': this.dataForm.code,
                        'positionName': this.dataForm.name,
                        'tenantId': sessionStorage.getItem('tenantId'),
                        'mainBodyId': sessionStorage.getItem('mainBodyId')
                    }
                ).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                    this.dataListLoading = false
                })
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            // 新增 / 修改
            addOrUpdateHandle(id) {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(id)
                })
            },
            // 关联组织机构
            orgUpdateHandle() {
                this.orgUpdateVisible = true
                let ids = this.dataListSelections.map(item => {
                    return item.id
                })
                if (ids.length < 1) {
                    this.$message({
                        message: '请先选择岗位！',
                        duration: 1500
                    })
                    return
                }
                this.$nextTick(() => {
                    this.$refs.orgUpdate.init(ids)
                })
            },
            dataAuthorityUpdateHandle(){
                this.dataAuthorityUpdateVisible = true
                let ids = this.dataListSelections.map(item => {
                    return item.id
                })
                if (ids.length < 1) {
                    this.$message({
                        message: '请先选择岗位！',
                        duration: 1500
                    })
                    return
                }
                this.$nextTick(() => {
                    this.$refs.dataAuthorityUpdate.init(ids)
                })
            },
            // 删除
            deleteHandle(id) {
                this.$confirm(`确定进行删除操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deletePosition(
                        {}, id
                    ).then(data => {
                        if (data && data.code === '00') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.getDataList()
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {
                })
            }
        }
    }
</script>
